import { GetRegion } from '../../../constants';

const URL_ORIGIN = 'www.clarovideo.com';
const URL_DOWNLOAD_APP_BASE = 'webclient/sk_core/swf/CentrodeDescarga';
const URL_DOWNLOAD_APP_IOS =
  'https://itunes.apple.com/app/clarovideo/id568894377?mt=8';
const URL_DOWNLOAD_APP_WINDOWS_10 =
  'ms-windows-store://pdp/?productid=9WZDNCRFJCPR';
const URL_DOWNLOAD_APP_ANDROID =
  'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.dla.android';

export const USER_AGENT = {
  NONE: 'NONE',
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  MAC: 'MAC',
  WINDOWS: 'WINDOWS',
  LINUX: 'LINUX',
  WINDOWS_TEN: 'WINDOWS_TEN',
};

export const getPlatform = () => {
  const platform = navigator.platform.toUpperCase();
  if (navigator) {
    if (/(Windows Phone 10.0)/.test(navigator.userAgent)) {
      return USER_AGENT.WINDOWS_TEN;
    }
    if (/android/i.test(navigator.userAgent)) {
      return USER_AGENT.ANDROID;
    }
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      return USER_AGENT.IOS;
    }
    if (/(Windows 10.0|Windows NT 10.0)/.test(navigator.userAgent)) {
      return USER_AGENT.WINDOWS_TEN;
    }
    if (platform.indexOf('MAC') !== -1) {
      return USER_AGENT.MAC;
    }
    if (platform.indexOf('WIN') !== -1) {
      return USER_AGENT.WINDOWS;
    }
    if (platform.indexOf('LINUX') !== -1) {
      return USER_AGENT.LINUX;
    }
  }
  return USER_AGENT.NONE;
};

export const getDownloadLink = groupId => {
  const platform = getPlatform();
  switch (platform) {
    case USER_AGENT.WINDOWS_TEN:
      return URL_DOWNLOAD_APP_WINDOWS_10;

    case USER_AGENT.WINDOWS:
      return `https://${URL_ORIGIN}/${URL_DOWNLOAD_APP_BASE}.msi`;

    case USER_AGENT.MAC:
      return `https://${URL_ORIGIN}/${URL_DOWNLOAD_APP_BASE}.pkg`;

    case USER_AGENT.IOS:
      return URL_DOWNLOAD_APP_IOS;

    case USER_AGENT.ANDROID:
      return URL_DOWNLOAD_APP_ANDROID;

    case USER_AGENT.LINUX:
    case USER_AGENT.NONE:
    default:
      return null;
  }
};

export const getDeepLink = groupId => {
  const platform = getPlatform();
  const deepLink = `dlaapk://${URL_ORIGIN}/${GetRegion()}/catalogo?autoplay=${groupId}&showPlayer=false`;
  switch (platform) {
    case USER_AGENT.WINDOWS_TEN:
      return deepLink;

    case USER_AGENT.IOS:
      return deepLink;

    case USER_AGENT.ANDROID:
      return deepLink;

    default:
      return null;
  }
};

export const isPlatformValidToConfig = () => {
  // aquí se configuran los dispositivos para mostrar la barra de configuración
  const platform = getPlatform();
  switch (platform) {
    case USER_AGENT.MAC:
    case USER_AGENT.LINUX:
    case USER_AGENT.WINDOWS:
    case USER_AGENT.WINDOWS_TEN:
      return true;
    default:
      return false;
  }
};
